import { render, staticRenderFns } from "./VolgogradPage.vue?vue&type=template&id=0b68a32a"
import script from "./VolgogradPage.vue?vue&type=script&lang=js"
export * from "./VolgogradPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports